goog.provide('el8.app.settings.idProofingQuiz');

goog.require('el8.service.urls');
goog.require('el8.template.app.settings.dialog.idProofingQuiz');
goog.require('el8.uiwidget.nonAlarmingAlert');
goog.require('el8.uiwidget.Form');
goog.require('el8.uiwidget.FormDialog');

//
// Show questions we got from Experian which they call Knoledge IQ (sm)
//
el8.app.settings.idProofingQuiz = (function() {
    var questionSetList = null;

    var that = new el8.uiwidget.FormDialog({
        title: 'Please Verify Your Identity',
        width: 660,
        autoHeight: true,
        position: {'my': 'center'}, // make sure it's centered (see note in NewDialog)
        contentFn: function() {
            return el8.template.app.settings.dialog.idProofingQuiz.content();
        }
    });

    that._createForm = function (questionSetList) {
        var fields = [];

        _(questionSetList).each(function (qSet, i) {
            var f = _(qSet).extend({
                // Note: the field itself is passed to the tmplFn. Also we strip \'s here
                // since Experian puts them in the text...
                text_cleaned: qSet.text.replace(new RegExp('\\\\', 'g'), ''),
                name: 'question_q_'+i,    // same as below, but required for getMapped()
                tmplFn: el8.template.app.settings.dialog.idProofingQuiz.questionSet,
                validate: {required: true}
            });

            fields.push(f);
        });

        var form = new el8.uiwidget.Form({
            fields: fields,
            noFirstFocus: true,
            validationOpts: el8.util.validate.standardOpts
        });
        form.addButton('send', 'Verify Answers', that._sendHandler, true);
        form.addCancelButton(function() { that.hide(); }, false);
        that.setForm(form);
    };

    that._sendHandler = function () {
        var form = that.getForm();

        if (!form.isValid()) {
            el8.uiwidget.nonAlarmingAlert('Please answer all the questions to continue');
            return false;
        }

        $.el8_ajax({
            url: el8.service.urls.get('idpQuiz'),
            type: 'POST',
            data: JSON.stringify({
                answers: form.getMapped()
            }),
            success: function(data) {
                if (el8React) {
                    // The current limitation of this flow is that only the current user can idproof themselves
                    // Due to this limitation we are direcrtly using the global USER_ID
                    el8React.dispatch.fetchUserIdProofStatus(el8Globals.PRACTICE_ID, el8Globals.USER_ID, true);
                } 
                that.hide();
                if (data) {
                    el8.uiwidget.nonAlarmingAlert('Your identity has been verified. No further action is required.');
                } else {
                    el8.uiwidget.nonAlarmingAlert('Your identity could not be verified. The Elation team will reach out to assist you. Please move forward for now.');
                }
            },
            error: function() { that.getForm().enable(); }
        });
    };

    var super_show = that.show;

    // questionSetList passed in
    that.show = function(questionSetList) {
        // if this has been loaded before, clear the content for the new form
        if (that.getForm()) {
            that.setContent(el8.template.app.settings.dialog.idProofingQuiz.content());
        }

        that._createForm(questionSetList);
        super_show.call(that);
        that.adjustPosition();
    };

    var super_hide = that.hide;
    that.hide = function() {
        super_hide.call(that);
        questionSetList = {};
    };

    return that;
})();
